import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { HotToastService } from '@ngneat/hot-toast';
import { GroupSharingService } from '../group-sharing.service.component';

@Component({
  selector: 'app-join-group-popup',
  templateUrl: './join-group-popup.component.html',
  styleUrls: ['./join-group-popup.component.scss']
})
export class JoinGroupPopupComponent implements OnInit, OnChanges {
  meetingId: any;
  name: any;
  // token:any;
  eventsList: any=[];
  @Input() eventId: any;
  @Output() token = new EventEmitter();
  @Input() eventSelected: boolean;
  constructor(
    public groupSharingService: GroupSharingService,
    private toast: HotToastService
  ) { }
  // /public dialogRef: MatDialogRef<GroupSharingComponent>
  // @Optional() @Inject(MAT_DIALOG_DATA) public data:any
  ngOnInit(): void {
    // this.getToken();
    this.getActiveParties();
    this.groupSharingService.socketObservable.subscribe((res) => {
      if (res && res != undefined && Object.keys(res).length != 0) {
        this.getActiveParties()
      }

    })

    this.groupSharingService.joinFromInvite$.subscribe((res) => {
      if (res && res != undefined) {
        this.eventId = res.eventId;
        this.meetingId = this.eventsList.find((v) => v.eventId == res.eventId).roomId
        this.getParticipantToken(res)
      }
    })
  }

  closeDialog() {
    //  this.dialogRef.close()
  }

  joinGroup() {
    //this.dialogRef.close({meetingId: this.meetingId, token: this.token, entryRequested: true})
  }

  getToken() {
    this.groupSharingService.getTokenForOtherParticipants().subscribe((res) => {
      //  this.token = res.token;
    })
  }

  getActiveParties() {

    this.eventsList=[]
    this.groupSharingService.getActiveWatchParty(this.eventId).subscribe((res) => {

      let item: any = '';
      if (localStorage.getItem('userData')) {
        item = JSON.parse(localStorage.getItem('userData'))
      }
      res.forEach(element => {
        if (element.participants.find((v) => v.userId === item.userId && v.status !== 'DELETED')) {
          this.eventsList.push(element)
        }
      });

      //this.getParticipantToken();
    }, err => {

    })
  }

  getParticipantToken(item) {
    this.groupSharingService.getParticipantToken(this.eventId, item.customRoomId).subscribe((res) => {

      //this.eventsList = res;
      this.token.emit({ token: res.token, roomId: this.meetingId, eventId: this.eventId, customRoomId: item.customRoomId });
    }, err => {

    })
  }

  joinGroupEvent(item) {
    navigator.mediaDevices.getUserMedia({ video: true, audio: true }).then((stream) => {
      this.meetingId = item.roomId;
      this.getParticipantToken(item);
      this.eventSelected = true;
    }).catch((err) => {
      console.error(`you got an error: ${err}`)
      this.toast.show(`Please allow Camera and Microphone to start the group sharing on spotlight.`, {
        theme: 'snackbar',
        position: 'top-right',
        duration: 5000
      })

    });

    // this.joinGroup()
  }

  ngOnChanges(changes:SimpleChanges){

  }
}
